type UrqlGqlModule =
  | typeof import('@pypestream/api-services/urql.limited-access.candidate').urqlGqlLimitedCandidate
  | typeof import('@pypestream/api-services/urql.limited-access.prodUS').urqlGqlLimitedProdUS
  | typeof import('@pypestream/api-services/urql.limited-access.prodEU').urqlGqlLimitedProdEU
  | typeof import('@pypestream/api-services/urql.limited-access.uat').urqlGqlLimitedUat
  | typeof import('@pypestream/api-services/urql.limited-access.main').urqlGqlLimitedMain
  | typeof import('@pypestream/api-services/urql.limited-access.qa1').urqlGqlLimitedQa1;

type UrqlGqlLimitedClient = Promise<UrqlGqlModule>;

export const ENV_MODULE_MAP: Record<string, () => UrqlGqlLimitedClient> = {
  prodUS: async () =>
    (await import('@pypestream/api-services/urql.limited-access.prodUS'))
      .urqlGqlLimitedProdUS,
  prodEU: async () =>
    (await import('@pypestream/api-services/urql.limited-access.prodEU'))
      .urqlGqlLimitedProdEU,
  uat: async () =>
    (await import('@pypestream/api-services/urql.limited-access.uat'))
      .urqlGqlLimitedUat,
  main: async () =>
    (await import('@pypestream/api-services/urql.limited-access.main'))
      .urqlGqlLimitedMain,
  candidate: async () =>
    (await import('@pypestream/api-services/urql.limited-access.candidate'))
      .urqlGqlLimitedCandidate,
  qa1: async () =>
    (await import('@pypestream/api-services/urql.limited-access.qa1'))
      .urqlGqlLimitedQa1,
};

export const setEnvModuleMapForTesting = (map: typeof ENV_MODULE_MAP) => {
  Object.assign(ENV_MODULE_MAP, map);
};

export const urqlClient = async (
  _host?: Location['host']
): UrqlGqlLimitedClient => {
  const { host: locationHost } = window.location;
  const host = _host || locationHost;

  let env;

  if (host.endsWith('pypestream.com')) {
    env = 'prodUS';
  }

  if (host.endsWith('pypestream.eu')) {
    env = 'prodEU';
  }

  if (host.endsWith('uat.pypestream.dev')) {
    env = 'uat';
  }

  if (host.endsWith('qa1.pypestream.dev')) {
    env = 'qa1';
  }

  if (host.endsWith('candidate.pypestream.dev')) {
    env = 'candidate';
  }

  if (env === undefined) {
    env = 'main';
  }

  // @todo - Remove before stable release
  console.log('Detected environment in design system:', env);

  const moduleLoader = ENV_MODULE_MAP[env];
  return moduleLoader();
};
